import { LectureVideoDetailResponse } from '../../../types/video'
import { useApiPostQuery } from '../useApi'

export const useVideosDetail = (requestData = {}) => {
  return useApiPostQuery<LectureVideoDetailResponse>(
    '/lectures/videos/detail',
    ['videosDetail', requestData],
    requestData,
    true
  )
}
